import * as PIXI from "pixi.js";
import {BaseButton} from "../core/Button";
import {PointUtil} from "../core/Geom";
import {ISignal} from "../core/Signal";

export type InteractionEvent = PIXI.InteractionEvent | undefined;
export type InteractionListener = (event: InteractionEvent) => void;

export interface IDraggable {
    readonly onStartDrag: ISignal<InteractionListener>;
    readonly onQuickClick: ISignal<InteractionListener>;
}

export function Draggable(this: BaseButton & IDraggable) {
    const downPoint = {x: 0, y: 0};
    let isDrag = false;
    let startDragTimeout: number;
    const startDragOnMove = (e: InteractionEvent) => {
        const p = e!.data.getLocalPosition(this.rootContainer);
        if (PointUtil.distance(downPoint, p) > 10) {
            startDrag(e);
        }
    };
    const startDrag = (e: InteractionEvent) => {
        clearTimeout(startDragTimeout);
        this.off("pointermove", startDragOnMove);
        if (!isDrag) {
            isDrag = true;
            this.onStartDrag(e!);
        }
    };
    this.onDown.add((b, e) => {
        isDrag = false;
        const p = e!.data.getLocalPosition(this.rootContainer);
        downPoint.x = p.x;
        downPoint.y = p.y;
        clearTimeout(startDragTimeout);
        this.off("pointermove", startDragOnMove);
        this.on("pointermove", startDragOnMove);
        startDragTimeout = window.setTimeout(() => {
            startDrag(e!);
        }, 200);
    });
    this.onClick.add((b, e) => {
        clearTimeout(startDragTimeout);
        this.off("pointermove", startDragOnMove);
        if (!isDrag) {
            this.onQuickClick(e);
        }
        isDrag = false;
    });
    const destroy = this.destroy;
    this.destroy = () => {
        this.onStartDrag.remove();
        this.onQuickClick.remove();
        clearTimeout(startDragTimeout);
        destroy.call(this);
    };
    return this;
}
